import Checkbox from '@components/Checkbox';
import MiniStepper from '@components/MiniStepper';
import Row from '@components/Row';
import Text from '@components/Text';
import colors from '@constants/colors';
import styled from '@emotion/styled';
import usePriceUnit from '@hooks/item/usePriceUnit';
import { ItemOption } from '@models/item';
import useOptionControl from '@store/item/hooks/useOptionControl';
import getGlobalName from '@utils/getGlobalName';
import { Fragment } from 'react';
import { useTranslation } from 'react-i18next';

import { getFormatedOptionPrice } from './utils/priceUtils';

interface Props {
    options: ItemOption[];
    optionGroupId: string;
    itemId: string;
}

function CheckboxOptions({ options, optionGroupId, itemId }:Props) {
    const {
        selectOption, isOptionSelected, removeOption, watchOptionCount, watchOptionMaxCount,
    } = useOptionControl({ itemId });
    const { t } = useTranslation('item');
    const priceUnit = usePriceUnit();
    return (
        <Fragment>
            {options.map((option) => {
                const {
                    name, salePrice, optionId, isChangeable, maxQuantity,
                    nameJa, nameEn,
                } = option;
                const optionName = getGlobalName({ nameJa, name, nameEn });
                const isPriceVisible = salePrice !== 0;
                const isStepperVisible = maxQuantity > 1
                    && isChangeable
                    && isOptionSelected({ optionId, optionGroupId });

                const handleCheckboxClick = () => {
                    if (isChangeable) {
                        if (isOptionSelected({ optionId, optionGroupId })) {
                            removeOption({ optionGroupId, option });
                        } else {
                            selectOption({
                                option, optionGroupId, amount: 1,
                            });
                        }
                    }
                };

                return (
                    <NoPaddingCheckbox key={optionId}
                        isChecked={isOptionSelected({ optionId, optionGroupId })}
                        disabled={!isChangeable}
                        onClick={handleCheckboxClick} >
                        <Row fullWidth justify='space-between'>
                            <Row>
                                {optionName}
                                {isPriceVisible && <PriceText color={colors.gray5} as='span' >
                                    {getFormatedOptionPrice(salePrice)}{priceUnit}
                                </PriceText>}
                            </Row>
                            {isStepperVisible && (
                                <MiniStepper value={watchOptionCount(optionId, optionGroupId)}
                                    min={0}
                                    increase={() => selectOption({ option, optionGroupId, amount: 1 })}
                                    decrease={() => selectOption({ option, optionGroupId, amount: -1 })}
                                    max={watchOptionMaxCount(optionId, optionGroupId)} />
                            )}
                        </Row>

                    </NoPaddingCheckbox>
                );
            })}
        </Fragment>
    );
}

const NoPaddingCheckbox = styled(Checkbox)`
    padding-right: 0;
`;

const PriceText = styled(Text)`
    margin-left: 8px;
`;

export default CheckboxOptions;
